module.exports = __webpack_public_path__ + "static/media/create_new_user.a7b98538.mov";